import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import grey from '@material-ui/core/colors/grey';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { isMobile } from '../utils/MobileCheck';

import { showCancelApplicationDialog } from '../actions/imstat';
import { ICareerInfo, ICurriculumInfo } from '../actions/search';
import MessageDialog from '../components/MessageDialog';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ImstatScenarioFactory, {
	ICancelApplicationParam,
} from '../scenario/ImstatScenarioFactory';
import SearchScenarioFactory from '../scenario/SearchScenarioFactory';
const styles = (theme: Theme) =>
	createStyles({
		cellItemName: {
			backgroundColor: grey[300],
			minWidth: '150px',
			textAlign: 'right',
			width: '20%',
		},
		cellItemValue: {
			textAlign: 'left',
			width: '80%',
		},
		column: {
			display: 'inline-block',
			textAlign: 'center',
			width: '33.33%',
		},
		flex: {
			flex: 1,
		},
		mobileCellItemName: {
			alignItems: 'center',
			backgroundColor: grey[300],
			display: 'flex',
			minHeight: '40px',
			minWidth: '10px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileCellItemValue: {
			alignItems: 'center',
			display: 'flex',
			minHeight: '40px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileTable: {
			minWidth: '100px',
		},
		root: {
			flexGrow: 1,
			padding: 18,
			wordBreak: 'break-all',
		},
		wrapDiv: {
			margin: '10px',
		},
	});

interface IRouteParams {
	career_id: IState['careerID'];
	class_id: IState['classID'];
	apl_type: IState['aplType'];
}

interface IRouteState {
	skillViewFlg: boolean;
	caller: Parameters<IProps['pushHistory']>[0];
}

interface IState {
	aplType: string;
	careerID: string;
	careerTitle: string;
	classID: string;
}

/**
 * 申請取消
 */
class ApplicationCancel extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			aplType: '',
			careerID: '',
			careerTitle: '',
			classID: '',
		};

		this.onDialogOk = this.onDialogOk.bind(this);
		this.cancelApplication = this.cancelApplication.bind(this);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.match || !this.props.match.params) {
			return;
		}

		const careerID = this.props.match.params.career_id;
		const classID = this.props.match.params.class_id;
		const aplType = this.props.match.params.apl_type;

		this.setState({
			aplType,
			careerID,
			classID,
		});
		const setDataELearning = (careerInfo: ICareerInfo) => {
			this.setState({
				careerTitle: careerInfo.careerTitle || '',
			});
		};

		const setDataCurriculum = (curriculumInfo: ICurriculumInfo) => {
			this.setState({
				careerTitle: curriculumInfo.careerName || '',
			});
		};

		if (aplType === '0' || aplType === '1' || aplType === '2') {
			this.props
				.doFetchCareerDetail(this.props.token, careerID)
				.then(data => setDataELearning(data.careerInfo));
		} else if (aplType === '3' || aplType === '4') {
			this.props
				.doFetchCurriculumDetail(this.props.token, careerID)
				.then(data => setDataCurriculum(data.curriculumInfo));
		}
	}

	public render() {
		const { classes } = this.props;
		const skillViewFlg = this.props.location.state.skillViewFlg;
		return (
			<div className={classes.root}>
				<div className={classes.wrapDiv}>
					<Paper>
						{!isMobile() && (
							<Table>
								<TableBody>
									<TableRow>
										<TableCell
											className={classes.cellItemName}
										>
											{skillViewFlg
												? i18n.t(
														'ApplicationCancel_0001'
												  )
												: i18n.t(
														'ApplicationCancel_0002'
												  )}
										</TableCell>
										<TableCell
											className={classes.cellItemValue}
										>
											{this.state.careerTitle}
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						)}
						{isMobile() && (
							<div className={classes.mobileTable}>
								<div className={classes.mobileCellItemName}>
									{i18n.t('ApplicationCancel_0002')}
								</div>
								<div className={classes.mobileCellItemValue}>
									{this.state.careerTitle}
								</div>
							</div>
						)}
					</Paper>
				</div>
				<Grid container={true} justify={'flex-start'}>
					{!skillViewFlg && (
						<Grid item={true}>
							{this.state.aplType === '0' &&
								i18n.t('ApplicationCancel_0003')}
							{this.state.aplType === '1' &&
								i18n.t('ApplicationCancel_0004')}
							{this.state.aplType === '2' &&
								i18n.t('ApplicationCancel_0005')}
							{this.state.aplType === '3' &&
								i18n.t('ApplicationCancel_0006')}
							{this.state.aplType === '4' &&
								i18n.t('ApplicationCancel_0007')}
						</Grid>
					)}
					{skillViewFlg && (
						<Grid item={true}>
							{this.state.aplType === '0' &&
								i18n.t('ApplicationCancel_0008')}
							{this.state.aplType === '1' &&
								i18n.t('ApplicationCancel_0009')}
							{this.state.aplType === '2' &&
								i18n.t('ApplicationCancel_0010')}
						</Grid>
					)}
				</Grid>
				<Grid container={true} justify={'center'}>
					<Grid item={true}>
						<Button
							variant="contained"
							color="primary"
							onClick={this.cancelApplication}
						>
							{i18n.t('ApplicationCancel_0011')}
						</Button>
					</Grid>
				</Grid>
				<MessageDialog
					open={this.props.dialogOpen}
					showCancelButton={false}
					title={i18n.t('ApplicationCancel_0012')}
					contents={[{ content: 'LMCM_I_00528' }]}
					onClose={this.onDialogOk}
					onClickOk={this.onDialogOk}
				/>
			</div>
		);
	}

	/**
	 * メッセージダイアログと申請取消画面をクローズ
	 */
	protected onDialogOk() {
		this.props.onClose();
		this.props.pushHistory(this.props.location.state.caller);
	}

	/**
	 * 申請取消
	 * @param event イベントオブジェクト
	 */
	protected cancelApplication(event: React.MouseEvent<HTMLElement>) {
		const { userAttr, token } = this.props;
		const { aplType, careerID, classID } = this.state;

		this.props.cancelApplication(token, {
			aplType,
			careerID,
			classID,
			userAttr,
		});
	}
}

const mapStateToProps = (state: IRootState) => ({
	dialogOpen: state.imstat.cancelApplication.dialogOpen,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	cancelApplication: (token: string, arg: ICancelApplicationParam) => {
		const s = ImstatScenarioFactory.createCancelApplication(
			dispatch,
			token
		);
		s.run(arg);
	},
	doFetchCareerDetail: (token: string, careerID: string) => {
		const s = SearchScenarioFactory.createDoFetchCareerDetail(
			dispatch,
			token
		);
		return s.run(careerID);
	},
	doFetchCurriculumDetail: (token: string, careerID: string) => {
		const s = SearchScenarioFactory.createDoFetchCurriculumDetail(
			dispatch,
			token
		);
		return s.run(careerID);
	},
	onClose: () => dispatch(showCancelApplicationDialog({ dialogOpen: false })),
	pushHistory: (path: string) => dispatch(push(path)),
});

// tslint:disable-next-line: no-empty-interface
export interface IApplicationCancelProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	IApplicationCancelProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ApplicationCancel);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<IApplicationCancelProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/ApplicationCancel.tsx